import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../api/client";
import "./ReportsPage.css";

function ReportCard({ title, icon, description, lastGenerated, onView, onDownload }) {
  const hasToday = lastGenerated && lastGenerated === new Date().toISOString().slice(0, 10);

  return (
    <div className="rp-card" onClick={onView}>
      <div className="rp-card-top">
        <div className="rp-card-icon">{icon}</div>
        <div className="rp-card-desc">{description}</div>
      </div>
      <div className="rp-card-bottom">
        <div className="rp-card-info">
          <div className="rp-card-title">
            <span className={`rp-card-dot ${hasToday ? "rp-dot-green" : "rp-dot-grey"}`} />
            {title}
          </div>
          <div className="rp-card-meta">
            {lastGenerated ? `עדכון אחרון: ${lastGenerated}` : "טרם נוצר"}
          </div>
        </div>
        {onDownload && (
          <button
            type="button"
            className="rp-card-download"
            onClick={(e) => { e.stopPropagation(); onDownload(); }}
            title="הורד PDF"
          >
            ⬇
          </button>
        )}
      </div>
    </div>
  );
}

export default function ReportsPage() {
  const navigate = useNavigate();
  const [latestDate, setLatestDate] = useState(null);

  useEffect(() => {
    apiClient.get("/reports/daily/latest")
      .then((res) => setLatestDate(res.data.date))
      .catch(() => {});
  }, []);

  const handleDownloadLatest = async () => {
    try {
      const res = await apiClient.get(`/reports/daily/${latestDate}/pdf`, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement("a");
      a.href = url;
      a.download = `daily-report-${latestDate}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch {
      alert("PDF לא זמין עדיין");
    }
  };

  return (
    <div className="rp-page">
      <div className="rp-header">
        <h1 className="rp-title">דוחות</h1>
        <p className="rp-subtitle">צפייה, ניווט והורדת דוחות תפעוליים</p>
      </div>
      <div className="rp-grid">
        <ReportCard
          title="דוח יומי"
          icon="📊"
          description="תמונת מצב יומית — LTV, בטוחות, קובננטים, מניות חופשיות והתראות פעילות"
          lastGenerated={latestDate}
          onView={() => navigate("/reports/daily")}
          onDownload={latestDate ? handleDownloadLatest : null}
        />
      </div>
    </div>
  );
}
